<template>
  <div class="st-select">
    <van-popup v-model:show="showPicker" round position="bottom" :close-on-click-overlay="false">
			<van-datetime-picker
				:type="dateType"
				v-model="defVal"
				title="请选择日期"
				@cancel="pickerCancel"
				@confirm="pickerConfirm"
			/>
    </van-popup>
    <div :data-readonly="readonly ? 1 : 0" style="position: relative;">
      <van-field
        class="st-form-item-input"
        ref="select-input"
        is-link
        v-model="text"
        :name="name"
        label=""
        :placeholder="placeholder"
        @click="onClick"
        readonly
				clearable
      />
			<div @click="clearVal" v-if="val && clearable" style="display: inline-block;position: absolute;top: 10px;right: 40px;font-size: 20px;color: #f1b9b9;"><van-icon name="close" /></div>
			
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    name: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    label: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    placeholder: {
      type: String,
      default: () => {
        return '';
      }
    },
    readonly: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
		clearable: {
		  type: Boolean,
		  default: () => {
		    return false;
		  }
		},
		dateType: {
			type: String,
			default: () => {
			  return 'datetime';
			}
		}
		
  },
  data() {
    return {
      showPicker: false,
      val: this.value,
      text: this.defText,
      pickerVal: 0,
			defVal: new Date(new Date().getTime()),
    };
  },
  created() {
    this.init();
    setTimeout(() => {
      this.$watch('value', (newV, oldV) => {
        if (newV !== oldV) {
          this.val = newV;
          this.setText();
        }
      });

      this.$watch('text', (newV, oldV) => {
        if (newV !== oldV) {
          this.$emit('changeText', this.text);
        }
      });
    }, 0)
  },
  mounted() {
  },
  watch: {},
  methods: {
    init() {
      this.setText();
    },
    // 设置要显示的文本
    setText() {
			if (!this.val) {
				this.text = '';
				this.defVal = new Date(new Date().getTime());
			} else {
				let newTime = new Date(this.val);
				let newTimeText = this.$formatDate(newTime, "yyyy年MM月dd日");
				this.defVal = new Date(new Date(this.val).getTime());
				this.text = newTimeText;
			}
    },
    // 点击输入框
    onClick() {
      this.showPicker = true;
      this.$emit('click');
    },
		
		clearVal() {
			this.val = '';
			this.text = '';
			this.$emit('input', this.val);
		},
    // 选择确定提交
    pickerConfirm(obj, ind) {
			let newTime = new Date(this.defVal);
			this.val = this.$formatDate(newTime, "yyyy-MM-dd");
      this.$emit('change', this.val, this.text)
      this.$emit('input', this.val);

      // 触发input blur 事件
      this.emitInputBlur();
      this.showPicker = false;
    },

    // 触发input blur 事件
    emitInputBlur() {
      this.$nextTick(() => {
        let ele = this.$refs['select-input'].$el.querySelector('input');
        ele.focus();
        ele.blur();
      })
    },

    // 取消选择
    pickerCancel() {
      this.showPicker = false;
      // 触发input blur 事件
      this.emitInputBlur();
    },

  },
};
</script>

<style lang="scss" scoped>
.st-select {
  .van-field {
    box-shadow: inset 0 0 0 2px rgb(223,223,223);
    border-radius: 5px;
  }

  div[data-readonly='1'] .van-field{
    background-color: rgba(233, 233, 233, 1);
  }
}
</style>
